module.exports = __webpack_public_path__ + "img/money-white.218b55e3.svg";